<template>
    <div
        class="setting-country-list"
    >
        <div class="setting-country-list__search-bar">
            <input
                v-model="filterQuery"
                :placeholder="$t('app.userSetting.countryFilterInputPlaceholder')"
                type="text"
            >
            <PtIcon
                icon="SolidSearchLeft"
                style="font-size: 24px;"
            />
        </div>
        <div
            v-if="countryList.length"
            class="setting-country-list__content"
        >
            <div
                v-for="({country, label}, index) in countryList"
                :key="index"
                :class="[
                    'setting-country-list__item',
                    country,
                    country === currentSelectedCountry ?'selected':''
                ]"
                @click="changeSelect(country)"
            >
                <span>{{ label }}</span>
            </div>
        </div>
        <div
            v-else
            class="setting-country-list__no-data"
        >
            {{ $t('app.userSetting.nodata') }}
        </div>
    </div>
</template>

<script>
import forEach from 'lodash/forEach';
import includes from 'lodash/includes';
import concat from 'lodash/concat';
import PtIcon from '@patsnap-biz/icon';
import { settingConfig } from '../settingConfig';

export default {
    components: {
        PtIcon,
    },
    props: {
        countryListConfig: {
            type: Object,
            default: () => ({}),
        },
        groupFamily: {
            type: Array,
            default: () => ([]),
        },
    },
    data() {
        return {
            currentSelectedCountry: '',
            filterQuery: '',
        };
    },
    computed: {
        /**
         * 1. 第一个下拉菜单不能存在请选择选项
         * 2. 前一个下拉菜单为请选择，后面下拉菜单选项只有请选择
         */
        countryList() {
            const countryList = [];
            let authorityTypeArr = ['_'];
            if (this.countryListConfig.currentKey === 1) {
                authorityTypeArr = [...settingConfig.authorityType];
            } else if (this.countryListConfig.currentKey <= this.groupFamily.length + 1) {
                authorityTypeArr = concat(authorityTypeArr, settingConfig.authorityType);
            }
            forEach(authorityTypeArr, (country) => {
                const label = country === '_' ? this.$t('app.userSetting._')
                    : `${country} - ${this.$t(`commonCountry.${country}`)}`;
                const labelUpper = label.toUpperCase();
                const filterUpper = this.filterQuery.toUpperCase();
                if (filterUpper && country === '_') return;
                if (includes(labelUpper, filterUpper) || includes(country, filterUpper)) {
                    countryList.push({
                        label,
                        country: country === '_' ? '' : country,
                    });
                }
            });
            return countryList;
        },
        isOpen() {
            return this.currentKey >= 0;
        },
        currentKey() {
            return this.countryListConfig.currentKey;
        },
    },
    watch: {
        currentKey() {
            this.scrollToSelect();
            this.filterQuery = '';
        },
    },
    methods: {
        changeSelect(country) {
            this.$emit('updateSelectCountry', country);
        },
        scrollToSelect() {
            this.currentSelectedCountry = this.countryListConfig.countryData;
            this.$nextTick(() => {
                if (this.$el.querySelector('.selected')) {
                    const scrollTop = this.$el.querySelector('.selected').offsetTop;
                    this.$el.querySelector('.setting-country-list__content').scrollTop = scrollTop;
                }
            });
        },
    },
};
</script>
